<aura-edit-wrapper
  [title]="'Mot de passe'"
  [(isEditing)]="isEditing"
  [isAllowedToEdit]="isAllowedToEdit()"
  (saved)="savePassword($event)"
  [showDivider]="true"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing() && isAllowedToEdit()) {
    <div class="pb-4">
      <aura-password-confirm-form
        [clearFormSignal]="shouldClear()"
        [allReadonly]="!editWrapper.isEditing()"
        (validityChanged)="editWrapper.onValidityChanged($event)"
        (dtoChanged)="editWrapper.onDtoChanged($event)"
      />
    </div>
  } @else {
    @if (lastUpdateAt(); as lastUpdateAt) {
      <div>Dernière modification: {{ lastUpdateAt | luxonDate: 'humanize' }}</div>
    } @else {
      <div>Vous n'avez jamais modifié votre mot de passe</div>
    }
  }
</aura-edit-wrapper>
